//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentBillingProfileInputItem } from './StudentBillingProfileInputItem';
import { StudentStatus } from './Enums';

export abstract class ChildDetailsInputItem extends ItemBase {
    Status: StudentStatus = StudentStatus.Active;
    DateOfBirth: string | null = null;
    DateStarted: string | null = null;
    FaceTimeID: string | null = null;
    SkypeUsername: string | null = null;
    Gender: string | null = null;
    LocalSchool: string | null = null;
    Note: string | null = null;
    Referrer: string | null = null;
    SkillLevel: string | null = null;
    SendEmailReminders: boolean = false;
    SendSMSReminders: boolean = false;
    SubjectTypes?: string[];     // OBSOLETE - Use only for compatibility
    TagIDs?: string[];
    BillingProfiles: StudentBillingProfileInputItem[] = [];

    static readonly ClassName: string = "ChildDetailsInputItem";
}
